export const ForgotEmailRoutes: import('vue-router').RouteConfig[] = [
	{
		path: '/forgot-email',
		component: () => import('./pages/master.vue').then((m) => m.default),
		children: [
			{ path: `your-details`, component: () => import('./pages/index.vue').then((m) => m.default), },
			{ path: `your-email-address`, component: () => import('./pages/your-email-address.vue').then((m) => m.default), },
			{ path: '', redirect: 'your-details', },
		],
	},
];
